import React, { useState } from 'react';

//material mui components
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';

//styles
import withStyles from '@mui/styles/withStyles';

//icons
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

//hook
import { useGlobalState } from '../../Utilidades/useGlobalState';

//actions
import AsignaIdomaEtiquetas from '../../Actions/Generales/IdiomasAction';

//activos
import iconoEspanol from '../../Activos/Imagenes/Idioma/spanish.png';
import iconoIngles from '../../Activos/Imagenes/Idioma/english.png';
import iconoPortugues from '../../Activos/Imagenes/Idioma/portuguese.png';

//styles
import { styleButtonBar } from '../Tool/Style';


const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
));

const Idioma = () => {

    //Estilo de los iconos de la barra
    const classIcon = styleButtonBar();

    const { etiquetas, codigoIdioma, compania, dispatch} = useGlobalState();

    const [anchorEl, setAnchorEl] = useState(null);

    const Cerrar = () => {
        setAnchorEl(null);
    };

    const seleccionaIdiomaCerrar = (idioma) => (event) => {
        event.preventDefault();
    
        setAnchorEl(null);
        //Cambio de Idioma
        if (codigoIdioma !== idioma) // si el codigo de idima actual es distinto al idioma selecionado
        {
            AsignaIdomaEtiquetas(idioma, dispatch); // Asigna el idioma de las etiquetas estaticas
        }
    };

    const ClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };


    return (
        <React.Fragment>
            <div role='button' style={{color:'inherit', alignItems:'center', display:'flex'}}
               className={classIcon.Button} onClick={ClickMenu} aria-controls="Idioma-menu" aria-haspopup="true">
                <IconButton
                    className={classIcon.IconButton}
                    style={{ backgroundColor: compania.CfgNavIconBG }}
                    size="large">
                    <img src={
                          codigoIdioma === undefined || codigoIdioma === "ES" ? iconoEspanol : codigoIdioma === "EN" ? iconoIngles : iconoPortugues } />
                </IconButton>
                <KeyboardArrowDownIcon className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
            </div>
            <StyledMenu
                id="Idioma-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={Cerrar}
            >
                <MenuItem onClick={seleccionaIdiomaCerrar("ES")}>
                {etiquetas.General.Et_lblEs}
                </MenuItem>
                <MenuItem onClick={seleccionaIdiomaCerrar("EN")}>
                {etiquetas.General.Et_lblEn}
                </MenuItem>
            </StyledMenu>
        </React.Fragment>
    );
}

export default Idioma;